var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDecending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45249 16.8065C5.45249 17.0381 5.26474 17.2258 5.03314 17.2258C4.80154 17.2258 4.61379 17.0381 4.61379 16.8065V5.6576L2.81354 7.45784C2.64977 7.62161 2.38425 7.62161 2.22048 7.45784C2.05671 7.29407 2.05671 7.02855 2.22048 6.86479L4.14355 4.94171C4.63486 4.45041 5.43142 4.45041 5.92273 4.94171L7.8458 6.86479C8.00957 7.02855 8.00957 7.29407 7.8458 7.45784C7.68203 7.62161 7.41651 7.62161 7.25274 7.45784L5.45249 5.6576V16.8065Z",
    fill: "#626768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 15.129C10.4844 15.3606 10.6721 15.5484 10.9037 15.5484H17.6134C17.845 15.5484 18.0328 15.3606 18.0328 15.129C18.0328 14.8974 17.845 14.7097 17.6134 14.7097H10.9037C10.6721 14.7097 10.4844 14.8974 10.4844 15.129Z",
    fill: "#626768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 10.9355C10.4844 10.7039 10.6721 10.5161 10.9037 10.5161H15.0973C15.3289 10.5161 15.5166 10.7039 15.5166 10.9355C15.5166 11.1671 15.3289 11.3548 15.0973 11.3548H10.9037C10.6721 11.3548 10.4844 11.1671 10.4844 10.9355Z",
    fill: "#626768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4844 6.74193C10.4844 6.51032 10.6721 6.32257 10.9037 6.32257H12.5811C12.8128 6.32257 13.0005 6.51032 13.0005 6.74193C13.0005 6.97353 12.8128 7.16128 12.5811 7.16128H10.9037C10.6721 7.16128 10.4844 6.97353 10.4844 6.74193Z",
    fill: "#626768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDecending);
export default __webpack_public_path__ + "static/media/sort_decending.8cd286639b25a60d7d6dc76f3f111bc3.svg";
export { ForwardRef as ReactComponent };